<div class="topHead">
    <h2>Manage Tickets</h2>
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>

<div class="centerWrap">
    <div class="pageTitleBox">
        <h2>Manage Tickets</h2> 
    </div>
<div class="adminTabWrap">
    <div class="filterWrap">
        <div class="searchWrap">
            <input type="text" placeholder="Search by User Name" (keyup)="search($event)" />
        </div>
    </div>
    <mat-tab-group animationDuration="0ms" (selectedTabChange)="onSelectChange($event)">
        <mat-tab label="All" (click)="getTickets('',1,'created_dttm','DESC', 1)">
            <div class="tableWrap ticketTbl">
                <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                    <thead>
                        <tr>
                            <th><div mat-sort-header="first_name"><b></b> Ticket Raised by</div></th>
                            <th mat-sort-header="created_dttm">Requested on</th>
                            <th>Message</th>
                            <th>Enquiry Status</th>
                        </tr>
                    </thead>
                    <tbody>
                    <!--class="selectTr"-->
                        <tr  *ngFor="let values of userData; let i = index" >
                            <td>
                                <div class="userTdWrap">
                                    <a class="btn-link">  <span>{{values.first_name}} {{values.last_name}}</span></a>
                                </div>
                            </td>
                            <td>
                                {{values.created_dttm | date:'d MMM, y'}}
                            </td>
                            <td class="userTdWrap">
                                {{values.message}}
                            </td>
                            <td>
                                <ul class="userActionBtn ticketAct">
                                    <li *ngIf="values.status==1"><a href="javascript:void(0);" style="color: #6A8AE2;">New</a></li>
                                    <li *ngIf="values.status==1"><a href="javascript:void(0);" class="btn-link" (click)="markResolved(values.id)">MARK RESOLVED</a></li>
                                    <li *ngIf="values.status==3"><a href="javascript:void(0);" style="color: #FEAF38;" (click)="markResolved(values.id)">Viewed</a></li>
                                    <li *ngIf="values.status==2"><a href="javascript:void(0);">RESOLVED</a></li>

                                    <li><a href="javascript:void(0);"  class="btn-link" [routerLink]="['/ticket-detail']" [queryParams]="{id:values.id,status:values.status}">VIEW DETAILS</a></li>
                                    <li><a href="javascript:void(0);" class="btn-link second-link" (click)="openDletMdl(delete,values.id,'All')">Delete</a></li>
                                </ul>
                            </td>
                        </tr>
                        <tr style="background-color: white;" class="selectTr" *ngIf="(userData && userData.length == 0)"><td [attr.colspan]="4">No Record found.</td></tr>
                    
                    </tbody>
                </table>
            </div>
        </mat-tab>
        <mat-tab label="Resolved" (click)="getTickets('',0,'created_dttm','DESC', 2)" >
            <div class="tableWrap ticketTbl">
                <table class="mat-elevation-z8 w-100" matSort (matSortChange)="sortData($event)">
                    <thead>
                        <tr>
                            <th><div mat-sort-header="first_name"><b></b> Ticket Raised by</div></th>
                            <th mat-sort-header="created_dttm">Requested on</th>
                            <th>Message</th>
                            <th>Enquiry Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- class="selectTr" -->
                        <tr  *ngFor="let values of userData; let i = index">
                            <td>
                                <div class="userTdWrap">
                                    <a class="btn-link"> <span>{{values.first_name}} {{values.last_name}}</span></a>
                                </div>
                            </td>
                            <td>
                                {{values.created_dttm | date:'d MMM, y'}}
                            </td>
                            <td class="userTdWrap">
                                {{values.message}}
                            </td>
                            
                            <td>
                                <ul class="userActionBtn ticketAct">
                                    <li><a href="javascript:void(0);"  class="btn-link" [routerLink]="['/ticket-detail']" [queryParams]="{id:values.id, status:values.status}">VIEW DETAILS</a></li>
                                </ul>
                            </td>
                            <td>
                                <ul class="userActionBtn ticketAct">
                                    <li><a href="javascript:void(0);" class="btn-link second-link" (click)="openDletMdl(delete,values.id,'Resolved')">Delete</a></li>
                                </ul>
                            </td>
                        </tr>
                        <tr class="selectTr" style="background-color: white;" *ngIf="(userData && userData.length == 0)"><td [attr.colspan]="4">No Record found.</td></tr>
                    </tbody>
                </table>
            </div>
        </mat-tab> 
      </mat-tab-group>
    </div>  
</div>
<input type="hidden" (click)="open(update)" id="successMsg">
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<ng-template #update let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Ticket Status </h6>
                <p class="size18">Tickect has been resolved successfully.</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #delete let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Delete ticket</h6>
                <p class="size18">Are you sure you want to delete this ticket?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="deleteTicket()">Yes,
                    Delete</a>
            </div>
        </div>
    </div>
</ng-template>





